export const emailList =
    [
        'don@sharegratitude.com',
        'hashan.gunathilake@veracity.dev',
        'amila@veracity.dev',
        'akhila.abesinghe@veracity.dev',
        'chathuranga@veracity.dev',
        'akila.dunukara@veracity.dev',
        'm.nithmali@gmail.com'
    ]